import React, { useState, useEffect, useRef } from 'react'
import { Calendar as ReactCalendar } from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import useOnClickOutside from 'srcReact/helpers/hooks/useOnClickOutside'
import { formatDate, formatLastUpdateDate, getDateFormat2 } from 'srcReact/helpers/datetimeHelper'
import styles from './styles.module.scss'

export default function Calendar({
  size = 'medium',
  date,
  containerCSS,
  calendarCSS,
  setRef,
  defaultDate,
  handleDateChange,
  disabled = false,
  placeholder = '',
  displayFormat = getDateFormat2(),
  showIcon = false,
  ...rest
}) {
  const { t } = useTranslation()
  const [value, setValue] = useState(null)
  const [formattedValue, setFormattedValue] = useState('')
  const [isCalenderVisible, setIsCalenderVisible] = useState(false)
  const containerRef = useRef()
  const calendarInputRef = useRef(null)
  useEffect(() => {
    if (setRef) {
      setRef(calendarInputRef)
    }
    if (defaultDate) {
      setValue(defaultDate)
      const formattdedDate = formatLastUpdateDate(defaultDate, displayFormat, t)
      setFormattedValue(formattdedDate)
    }
  }, [])
  useEffect(() => {
    setValue(date)
    const formattdedDate = formatLastUpdateDate(date, displayFormat, t)
    setFormattedValue(formattdedDate)
  }, [date])

  const showCalendar = () => {
    if (!disabled) {
      setIsCalenderVisible(!isCalenderVisible)
    }
  }
  const hideCalendar = () => {
    setIsCalenderVisible(false)
  }

  const handleChange = (value) => {
    const selectedDate = new Date(value)
    //const selectedDateShort = new Date(value.getYear(), value.getMonth(), value.getDate())
    //  console.log('selectedDate', selectedDateShort)
    const selectedFormattedDate = formatLastUpdateDate(selectedDate, displayFormat, t)

    setValue(selectedDate)
    setFormattedValue(selectedFormattedDate)
    setIsCalenderVisible(false)
    handleDateChange(selectedDate)
  }
  useOnClickOutside(containerRef, hideCalendar)
  return (
    <div ref={containerRef} className={`${styles.calendarContainer} ${styles[size]} ${containerCSS}`}>
      <button disabled={disabled} className={styles.dateTextContainer} type='button' onClick={showCalendar}>
        <span type='text' className={styles.dateText}>
          {formattedValue || placeholder}
        </span>
        <Icon styleModifier={`${styles.calendarIcon} ${showIcon && styles.visibleIcon}`} name='calendar24' />
      </button>

      {isCalenderVisible && (
        <ReactCalendar
          inputRef={calendarInputRef}
          className={`${styles.calendar} ${calendarCSS}`}
          onChange={handleChange}
          value={value}
          format
          formatMonth={(locale, date) => formatDate(date, 'MMM')}
          formatShortWeekday={(locale, date) => formatDate(date, 'dd')}
          formatMonthYear={(locale, date) => formatDate(date, 'MMMM YYYY')}
          {...rest}
        />
      )}
    </div>
  )
}
